<template>
    <h5 class="swell-card-title"><slot></slot></h5>
</template>

<script>
    export default {}
</script>

<style lang="scss">
    .swell-card-title {
        padding: 1.25rem 1.25rem 0 1.25rem;
        margin-bottom: -10px;
        font-weight: 300;
        font-size: 20px;
    }
</style>
